import { useContext, useRef, useState } from 'react'

import { OTPForm } from '@paysense-india-services/auth-vista'
import { payufinSessionStorage } from '@paysense-india-services/payufin-jsutils'

import { PORTAL_HEADER_KEY, SEND_OTP_API, VERIFY_OTP_API } from '@/constants/api'
import { SESSION_STORAGE_KEYS } from '@/constants/sessionStorageKeys'

import { AuthContext } from '@/contexts/AuthContext'

import useBackNavigation from '@/hooks/useBackNavigation'

import Header from '@/components/Header'

const OtpPage = () => {
  const otpRef = useRef()
  const { loginUser } = useContext(AuthContext)
  const [error, setError] = useState(null)
  const { goBack } = useBackNavigation()

  const onVerifyOtpSuccess = data => {
    const { muid } = data || {}
    showSnackbar('OTP Verified Successfully', { type: 'success' })
    payufinSessionStorage?.setToSession(SESSION_STORAGE_KEYS.USER_MOBILE, null)
    payufinSessionStorage?.setToSession(SESSION_STORAGE_KEYS.MASTER_USER_ID, muid)
    loginUser(muid)
  }

  const getRequestBody = mobile => {
    return {
      data: {
        code: otpRef.current,
        phone: `+91${mobile}`
      },
      headers: {
        ...PORTAL_HEADER_KEY
      },
      credentials: 'include'
    }
  }

  const getResendOTPRequestBody = async initialData => {
    const { data, headers } = (await JSON.parse(initialData)) || {}
    return { data, headers }
  }

  return (
    <>
      <Header
        hideOnDesktop
        icon={{ name: 'leftArrow', fillColor: '#171717' }}
        onLeftIconClick={goBack}
      />
      <div className='ew-d-flex ew-flex-1 ew-align-items-center ew-justify-content-center ew-mt-md-24'>
        <OTPForm
          api={VERIFY_OTP_API}
          config={{
            title: 'Verify Phone Number',
            subTitle: `We have sent an OTP to +91 ${payufinSessionStorage.getFromSession(
              SESSION_STORAGE_KEYS.USER_MOBILE
            )}`
          }}
          error={error ?? { message: '' }}
          getRequestBody={getRequestBody}
          getResendOTPRequestBody={getResendOTPRequestBody}
          onError={err => setError(new Error(err.detail))}
          onOTPChange={otp => {
            setError(null)
            otpRef.current = otp
          }}
          onResendOTPError={() => showSnackbar('Something went wrong!!!')}
          onResendOTPSuccess={() => {
            setError(null)
            showSnackbar('OTP Sent Successfully', { type: 'success' })
          }}
          onSuccess={onVerifyOtpSuccess}
          resendApi={SEND_OTP_API}
          resendTimer={60}
        />
      </div>
    </>
  )
}

export default OtpPage
